import axios from "axios";
import React, { useState } from "react";
import { Button, Col, Container, Form, Row, Spinner } from "react-bootstrap";
import { useSignInWithEmailAndPassword } from "react-firebase-hooks/auth";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { auth } from "../../../firebase.init";
import login from "../../../img/login.svg";

import "./Login.css";
import SocialLogin from "./SocialLogin";

const Login = () => {
  // after login navigate
  const location = useLocation();
  const navigate = useNavigate();
  let from = location.state?.from?.pathname || "/";

  const [validated, setValidated] = useState(false);
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [signInWithEmailAndPassword, user, loading, error] =
    useSignInWithEmailAndPassword(auth);


  const handleSubmitLogin = async(event) => {
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else if (form.checkValidity()) {
      setEmail(event.target.email.value);
      setPass(event.target.pass.value);
    }

    setValidated(true);
  await signInWithEmailAndPassword(email, pass);
  const {data}=await axios.post('https://rocky-ravine-79485.herokuapp.com/login',{email})
   localStorage.setItem("token",data.accessToken)
};

  if (user) {
    navigate(from, { replace: true });
    document.getElementById("loginFrom").reset();
  }
  return (
    <div>
      <Container>
        <Row>
          <Col md={6}>
            <img src={login} alt="Login Now" />
          </Col>
          <Col className="my-5" md={6}>
            {" "}
            <Form
              id="loginFrom"
              onSubmit={handleSubmitLogin}
              noValidate
              validated={validated}
            >
              {/* Email */}
              <Form.Group
                as={Col}
                md="12"
                className="mt-3"
                controlid="validationCustom02"
              >
                <Form.Label>Email</Form.Label>
                <Form.Control
                  required
                  name="email"
                  type="email"
                  placeholder="mail@domain.com"
                  defaultValue=""
                />
                <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              </Form.Group>
              {/* password */}
              <Form.Group
                as={Col}
                md="12"
                className="my-3"
                controlid="validationCustom02"
              >
                <Form.Label>Password</Form.Label>
                <Form.Control
                  required
                  name="pass"
                  type="password"
                  placeholder="**********"
                  defaultValue=""
                />
                <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              </Form.Group>

              <Button variant="success" type="submit">
                Submit
              </Button>
              {loading ? (
                <span>
                  <Spinner className="" animation="border" variant="success" />
                </span>
              ) : (
                ""
              )}
            </Form>
            {error ? <span className="text-danger ">Invalid Email or Password</span>: ""}
            
            <br />
            <br />
            <span>Forget your <Link to={'/forget-password'}>password</Link>? </span>
            <br />
            <hr />
            {<SocialLogin></SocialLogin>}
            <br />
            <p>
              <Link to="/signup">
                {" "}
                <svg
                  width={15}
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z"
                    clipRule="evenodd"
                  />
                </svg>{" "}
                Sign Up{" "}
              </Link>
              now you don't have a account
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;
